import { HttpClient } from './HttpClient';
import { getShortlistsApiUrl } from './UrlBuilder';
import { IShortlists, INewShortlist, IShortlistPerformer } from 'models';
import { HttpOperationError } from 'shared/utils/exceptions';
import { HALManager } from 'app/core';
import { parseToUrlQuery } from 'shared/utils/http';

export class ShortlistService {
  private httpClient: HttpClient = new HttpClient();

  public async getShortList() {
    const urlRequest = getShortlistsApiUrl(HALManager.getShortListUrl(), parseToUrlQuery({ status: 'active' }));

    try {
      const { object: shortlists } = await this.httpClient.get<IShortlists>(urlRequest);
      return shortlists;
    } catch (error) {
      throw new HttpOperationError(urlRequest, 'Getting shortlist was failed');
    }
  }

  public async addShortList(shortlist: INewShortlist) {
    const urlRequest = getShortlistsApiUrl(HALManager.postShortListUrl());

    try {
      const { object: results } = await this.httpClient.post<any>(urlRequest, {
        body: JSON.stringify(shortlist),
      });

      return results;
    } catch (error) {
      throw new HttpOperationError(urlRequest, 'Getting shortlist was failed');
    }
  }

  public async addPerformerShortList(shortlistId: number, performer: IShortlistPerformer) {
    const urlRequest = getShortlistsApiUrl(HALManager.postPerformerShortListUrl(shortlistId));

    try {
      const { object: results } = await this.httpClient.post<any>(urlRequest, {
        body: JSON.stringify([performer]),
      });

      return results;
    } catch (error) {
      throw new HttpOperationError(urlRequest, 'Getting shortlist was failed');
    }
  }
}

export default new ShortlistService();
